module.exports = new __parcel__URL__("gif3.d22634dd.webm").toString();